import { createRouter, createWebHashHistory } from "vue-router";
import LoginView from "@/views/LoginView.vue";
import HeroInfoView from "@/views/HeroInfoView.vue";
import MainView from "@/views/MainView.vue";
import ServiceInfoView from "@/views/ServiceInfoView.vue";
import ManufacturerMaster from "@/views/ManufacturerMaster.vue"
import ModelMaster from "@/views/ModelMaster.vue"
import AboutUsedCar from "@/views/AboutUsedCar.vue"
import AboutUsedPart from "@/views/AboutUsedPart.vue"
import PointUsedCar from "@/views/PointUsedCar.vue"
import PointUsedPart from "@/views/PointUsedPart.vue"
import UsedCarList from "@/views/UsedCarList.vue"
import UsedPartList from "@/views/UsedPartList.vue";
import CompanyInfoView from "@/views/CompanyInfoView.vue"
import ContactInfoView from "@/views/ContactInfoView.vue"
import ProductList from "@/views/ProductList.vue"

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/main',
    name: 'Main',
    component: MainView,
    children: [
      {
        path: 'heroInfo',
        name: 'HeroInfo',
        component: HeroInfoView
      },
      {
        path: 'serviceInfo',
        name: 'serviceInfo',
        component: ServiceInfoView
      },
      {
        path: 'manufacturerMaster',
        name: 'manufacturerMaster',
        component: ManufacturerMaster
      },
      {
        path: 'modelMaster',
        name: 'modelMaster',
        component: ModelMaster
      },
      {
        path: 'aboutUsedCar',
        name: 'aboutUsedCar',
        component: AboutUsedCar
      },
      {
        path: 'aboutUsedPart',
        name: 'aboutUsedPart',
        component: AboutUsedPart
      },
      {
        path: 'pointUsedCar',
        name: 'pointUsedCar',
        component: PointUsedCar
      },
      {
        path: 'pointUsedPart',
        name: 'pointUsedPart',
        component: PointUsedPart
      },
      {
        path: 'usedCarList',
        name: 'usedCarList',
        component: UsedCarList
      },
      {
        path: 'usedPartList',
        name: 'usedPartList',
        component: UsedPartList
      },
      {
        path: 'companyInfoView',
        name: 'companyInfoView',
        component: CompanyInfoView
      },
      {
        path: 'contactInfoView',
        name: 'contactInfoView',
        component: ContactInfoView
      },
      {
        path: 'productList',
        name: 'productList',
        component: ProductList
      },
    ]
  }
];


const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果保存了滚动位置（例如浏览器的后退/前进操作），则返回保存的位置
    if (savedPosition) {
      return savedPosition;
    }
    // 否则默认滚动到顶部
    return { top: 0, left: 0 };
  },
});

export default router;
